export default [
    {
        path: '/earlyBirdList', // 早鸟票列表
        component: resolve => require(['@/pages/earlyBirdSale/allBirdSale'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/birdListSearch', // 早鸟票搜索
        component: resolve => require(['@/pages/earlyBirdSale/birdSearch'], resolve),
        meta: { title: "长龙航空" }
    },

]



// WEBPACK FOOTER //
// ./src/router/modules/sale.js